import { SwipeableDrawer } from "@mui/material";
import React, { useEffect, useRef } from "react";
import { IoCloseCircleSharp } from "react-icons/io5";

const EditTabelDrawer = ({ Edit, setEdit, children, shippingId }) => {
  const lastOpen = useRef(0);

  useEffect(() => {
    if (Edit?.open) {
      lastOpen.current = Date.now();
    }
  }, [Edit?.open]);

  const handleDrawerClose = (event, reason) => {
    // prevent spurious immediate close calls
    const now = Date.now();
    if (now - lastOpen.current < 300) return;

    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      setEdit({ open: false, edit: "", title: "" });
    }
  };

  return (
    <SwipeableDrawer
      anchor="right"
      open={Boolean(Edit?.open)}
      onClose={handleDrawerClose}
      onOpen={() => { }}
      disableSwipeToOpen
    >
      {Edit?.edit !== "marginOverride" &&
        Edit?.edit !== "globalMargin" &&
        Edit?.edit !== "shippingAlgo" && (
          <>
            <div className="p-3">
              <div className="d-flex justify-content-between align-items-center">
                <h4 className="font-weight-bold">{Edit?.title}</h4>
                <h4
                  onClick={() =>
                    setEdit({
                      open: false,
                      edit: "",
                      title: "",
                    })
                  }
                >
                  <IoCloseCircleSharp
                    style={{
                      fontSize: "22px",
                      color: "#fb2a3d",
                      cursor: "pointer",
                    }}
                  />
                </h4>
              </div>
              {Edit.edit !== "notes" && <p>{shippingId}</p>}
              {Edit.edit === "orderStatus" && (
                <span style={{ fontSize: "12px" }}>
                  (Please confirm{" "}
                  <strong>
                    Shipping & Tracking, Fraud, & sale Analysis
                  </strong>{" "}
                  before making available)
                </span>
              )}
            </div>
            <hr />
          </>
        )}
      {children}
    </SwipeableDrawer>
  );
};

export default EditTabelDrawer;
